import React from 'react';
import { useIntl } from 'react-intl';
import { REQUEST_ERROR_MESSAGES } from '../utils/messageKeys';
import { RangeControls } from './RangeControls';
import { RequestOptions } from './RequestOptions';
import { StatusMessage } from './StatusMessage';
import { TrailTimeline } from './TrailTimeline';
import { WindowHeader } from './WindowHeader';

export const ClipStep = ({ flow, onCancel }) => {
  const { formatMessage } = useIntl();
  const { window, range, unit, clip } = flow;

  let submitLabel = formatMessage({ id: 'requestVideo_submit' });
  if (clip.isSending) submitLabel = formatMessage({ id: 'requestVideo_sending' });

  return (
    <section className="request-video-section">
      <WindowHeader
        window={window}
        timeZone={unit.timeZone}
        canPrev={flow.canMoveWindow(-1)}
        canNext={flow.canMoveWindow(1)}
        onMove={flow.moveWindow}
      />
      <TrailTimeline
        window={window}
        trail={flow.trail}
        range={range}
        timeZone={unit.timeZone}
        rangeActions={flow.rangeActions}
        runs={flow.lmRuns}
        activeRun={flow.activeRun}
      />
      <RangeControls
        range={range}
        window={window}
        timeZone={unit.timeZone}
        error={flow.rangeError}
        rangeActions={flow.rangeActions}
      />
      <RequestOptions options={flow.options} canUsePrivate={flow.canUsePrivate} onChange={flow.setOptions} />
      <div className="request-video-footer">
        {clip.errorKind && <StatusMessage id={REQUEST_ERROR_MESSAGES[clip.errorKind]} tone="error" />}
        <div className="request-video-actions">
          {onCancel && (
            <button type="button" className="request-video-secondary" onClick={onCancel}>
              {formatMessage({ id: 'requestVideo_cancel' })}
            </button>
          )}
          <button type="button" className="request-video-primary" disabled={!flow.canSubmit} onClick={flow.submit}>
            {submitLabel}
          </button>
        </div>
      </div>
    </section>
  );
};
